import { ToggleUserFollowArgs } from 'types/api/arguments/toggle-user-follow-args'
import { ToggleUserFollowResp } from 'types/api/response/toggle-user-follow-resp'

import { api } from './api'

export const toggleUserFollow = ({ userId }: ToggleUserFollowArgs) =>
  api.post<ToggleUserFollowResp>('/followed_users/toggle', { user_id: userId })
